export default "__VITE_ASSET__18155a9e__"